import type { FC, ReactNode } from 'react'
import type { SlotStatus } from '@/types'

import { cn } from '@/lib/utils'

export const slotStatusMeta: Record<SlotStatus, { label: string, badge: string, dot: string }> = {
    'tersedia': {
        label: 'Tersedia',
        badge: 'bg-emerald-50 text-emerald-800 ring-emerald-200',
        dot: 'bg-emerald-500'
    },
    'hampir-penuh': {
        label: 'Hampir penuh',
        badge: 'bg-amber-50 text-amber-800 ring-amber-200',
        dot: 'bg-amber-500'
    },
    'penuh': {
        label: 'Penuh',
        badge: 'bg-rose-50 text-rose-700 ring-rose-200',
        dot: 'bg-rose-500'
    },
    'tidak-praktik': {
        label: 'Tidak praktik',
        badge: 'bg-slate-100 text-slate-500 ring-slate-200',
        dot: 'bg-slate-400'
    }
}

interface SlotStatusBadgeProps {
    status: SlotStatus
    className?: string
}

export const SlotStatusBadge: FC<SlotStatusBadgeProps> = ({ status, className }): ReactNode => {
    const meta = slotStatusMeta[status]

    return (
        <span className={cn('inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ring-inset', meta.badge, className)}>
            <span className={cn('size-1.5 rounded-full', meta.dot)} aria-hidden='true' />
            {meta.label}
        </span>
    )
}
